import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";


export const EarlyCheckInPopUP = (props) => {

    const { t } = props
    
    return (
        <section class="overlay">
			<div class="overlay-window-container">
				<div class="overlay-window">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title">
								<h2 style={{color: "#000 !important"}}>Attention</h2>
							</div>
							<div class="overlay-header-icon">
								<i class="fas fa-exclamation"></i>
							</div>
						</div>
						<div class="overlay-header-body">
                            <p>{props.errorMsg}</p>
							<p>{t('check_in.earlyCheckin_proceed')}</p>
						</div>
					</div>
					<div class="overlay-controls">
						<button onClick={() => props.proceedWithEarlyCheckIn()} class={`button w-100 ${process.env.REACT_APP_NEWER_DESIGN=="true" && "primary"}`}>{t('check_in.proceed')}</button>
						<button onClick={() => props.backBtn()} class={`button w-100 margin-top-1 ${process.env.REACT_APP_NEWER_DESIGN=="true" && "secondary"}`}>{t('check_in.close')}</button>
					</div>
				</div>
			</div>
		</section>
    )
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,
    }
  }

export default connect(mapStateToProps,{})(withTranslation('translations')(EarlyCheckInPopUP));